import { render, staticRenderFns } from "./DriversScreen.vue?vue&type=template&id=a2f90e96&scoped=true&"
import script from "./DriversScreen.vue?vue&type=script&lang=js&"
export * from "./DriversScreen.vue?vue&type=script&lang=js&"
import style0 from "./DriversScreen.vue?vue&type=style&index=0&id=a2f90e96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f90e96",
  null
  
)

export default component.exports